import React, { useState, useEffect } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Grid,
  LinearProgress,
  CircularProgress,
  Chip,
  Divider
} from '@material-ui/core'
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  AttachMoney as MoneyIcon,
  People as PeopleIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Cancel as CancelIcon,
  Star as StarIcon,
  Euro as EuroIcon
} from '@material-ui/icons'
import { tourApi } from '../api/tourApi'

// Estilos inline para el componente de estadísticas

const TourStats = () => {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadStats()
  }, [])

  const loadStats = async () => {
    setLoading(true)
    try {
      const response = await tourApi.getTourStats()
      setStats(response.data)
    } catch (err) {
      setError('Error loading statistics')
      console.error('Error loading stats:', err)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress size={60} />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '32px 0' }}>
        <Typography color="error" variant="h6" gutterBottom>
          {error}
        </Typography>
      </div>
    )
  }

  if (!stats) {
    return (
      <div style={{ textAlign: 'center', padding: '32px 0' }}>
        <Typography variant="h6" color="textSecondary">
          No statistics available
        </Typography>
      </div>
    )
  }

  const total = stats.total || 0
  const pending = stats.pending || 0
  const processed = stats.processed || 0
  const cancelled = stats.cancelled || 0
  const totalRevenue = stats.totalRevenue || 0

  const pendingPercentage = total > 0 ? (pending / total) * 100 : 0
  const processedPercentage = total > 0 ? (processed / total) * 100 : 0
  const cancelledPercentage = total > 0 ? (cancelled / total) * 100 : 0

  return (
    <div style={{ padding: 24 }}>
              <Grid container spacing={24}>
        {/* Tarjeta principal - Total de tours */}
        <Grid item xs={12} md={6} lg={3}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <PeopleIcon style={{ fontSize: '2rem', marginBottom: 8, color: 'white' }} />
                <Typography style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 8, color: 'white' }}>
                  {total.toLocaleString()}
                </Typography>
                <Typography style={{ fontSize: '0.875rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'white' }}>
                  Total Tours
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <TrendingUpIcon />
                  <Typography variant="caption" style={{ color: 'white' }}>
                    +12% this month
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>

                {/* Tarjeta de tours procesados */}
        <Grid item xs={12} md={6} lg={3}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%)',
            color: 'white'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <CheckCircleIcon style={{ fontSize: '2rem', marginBottom: 8, color: 'white' }} />
                <Typography style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 8, color: 'white' }}>
                  {processed.toLocaleString()}
                </Typography>
                <Typography style={{ fontSize: '0.875rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'white' }}>
                  Processed Tours
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <TrendingUpIcon />
                  <Typography variant="caption" style={{ color: 'white' }}>
                    {processedPercentage.toFixed(1)}% of total
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>

                {/* Tarjeta de tours pendientes */}
        <Grid item xs={12} md={6} lg={3}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            color: 'white'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <WarningIcon style={{ fontSize: '2rem', marginBottom: 8, color: 'white' }} />
                <Typography style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 8, color: 'white' }}>
                  {pending.toLocaleString()}
                </Typography>
                <Typography style={{ fontSize: '0.875rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'white' }}>
                  Pending Tours
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <ScheduleIcon />
                  <Typography variant="caption" style={{ color: 'white' }}>
                    {pendingPercentage.toFixed(1)}% of total
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>

                {/* Tarjeta de tours cancelados */}
        <Grid item xs={12} md={6} lg={3}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
            color: 'white'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <CancelIcon style={{ fontSize: '2rem', marginBottom: 8, color: 'white' }} />
                <Typography style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 8, color: 'white' }}>
                  {cancelled.toLocaleString()}
                </Typography>
                <Typography style={{ fontSize: '0.875rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'white' }}>
                  Cancelled Tours
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <TrendingDownIcon />
                  <Typography variant="caption" style={{ color: 'white' }}>
                    {cancelledPercentage.toFixed(1)}% of total
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>

                {/* Tarjeta de ingresos totales */}
        <Grid item xs={12} md={6}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
            color: '#2c3e50'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <MoneyIcon style={{ fontSize: '2rem', marginBottom: 8, color: '#2c3e50' }} />
                <Typography style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 8, color: '#2c3e50' }}>
                  €{totalRevenue.toLocaleString()}
                </Typography>
                <Typography style={{ fontSize: '0.875rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#2c3e50' }}>
                  Total Revenue
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <EuroIcon />
                  <Typography variant="caption" style={{ color: '#2c3e50' }}>
                    Average: €{(totalRevenue / Math.max(processed, 1)).toFixed(2)} per tour
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>

        {/* Tarjeta de tasa de conversión */}
        <Grid item xs={12} md={6}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
            color: '#2c3e50'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <StarIcon style={{ fontSize: '2rem', marginBottom: 8, color: '#2c3e50' }} />
                <Typography style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 8, color: '#2c3e50' }}>
                  {total > 0 ? ((processed / total) * 100).toFixed(1) : 0}%
                </Typography>
                <Typography style={{ fontSize: '0.875rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#2c3e50' }}>
                  Conversion Rate
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <CheckCircleIcon />
                  <Typography variant="caption" style={{ color: '#2c3e50' }}>
                    {processed} of {total} tours completed
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Gráfico de progreso */}
      <Card style={{
        borderRadius: 16,
        padding: 24,
        background: 'white',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        <CardContent>
          <Typography variant="h6" gutterBottom style={{ color: '#2c3e50', fontWeight: 600 }}>
            Tour Status Distribution
          </Typography>
          
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Processed Tours
              </Typography>
              <Chip 
                label={`${processed} (${processedPercentage.toFixed(1)}%)`}
                color="primary"
                size="small"
              />
            </div>
            <LinearProgress 
              variant="determinate" 
              value={processedPercentage}
              style={{ height: 8, borderRadius: 4 }}
              color="primary"
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Pending Tours
              </Typography>
              <Chip 
                label={`${pending} (${pendingPercentage.toFixed(1)}%)`}
                color="secondary"
                size="small"
              />
            </div>
            <LinearProgress 
              variant="determinate" 
              value={pendingPercentage}
              style={{ height: 8, borderRadius: 4 }}
              color="secondary"
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Cancelled Tours
              </Typography>
              <Chip 
                label={`${cancelled} (${cancelledPercentage.toFixed(1)}%)`}
                color="default"
                size="small"
              />
            </div>
            <LinearProgress 
              variant="determinate" 
              value={cancelledPercentage}
              style={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0' }}
            />
          </div>
        </CardContent>
      </Card>

            {/* Métricas adicionales */}
              <Grid container spacing={24} style={{ marginTop: 16 }}>
        <Grid item xs={12} md={4}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <Typography variant="h4" style={{ color: '#28a745', fontWeight: 600 }}>
                  {total > 0 ? ((processed / total) * 100).toFixed(1) : 0}%
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Success Rate
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <Typography variant="h4" style={{ color: '#ffc107', fontWeight: 600 }}>
                  {total > 0 ? ((pending / total) * 100).toFixed(1) : 0}%
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Pending Rate
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card style={{
            borderRadius: 16,
            padding: 24,
            height: '100%',
            transition: 'all 0.3s ease-in-out',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <CardContent>
              <div style={{ textAlign: 'center' }}>
                <Typography variant="h4" style={{ color: '#dc3545', fontWeight: 600 }}>
                  {total > 0 ? ((cancelled / total) * 100).toFixed(1) : 0}%
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Cancellation Rate
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}

export default TourStats 


// WEBPACK FOOTER //
// ./src/features/tours/components/TourStats.js